<script lang="ts">
	//

	import { feddbackApi } from './feddbackApi';

	$effect(() => {
		const script: HTMLScriptElement = (window as any).document.createElement('script');
		(window as any).document.querySelector('head').appendChild(script);

		script.setAttribute('defer', '');
		script.setAttribute('src', 'https://smartcaptcha.cloud.yandex.ru/captcha.js');

		return () => {
			script.remove();
		};
	});

	let isSended = $state(false);
	let errorMessage = $state('');

	function onsubmit(e) {
		e.preventDefault();

		feddbackApi(new FormData(e.currentTarget))
			.then((data) => {
				// console.log('data', data);
				isSended = true;
			})
			.catch((error) => {
				console.log('error', error);

				errorMessage = 'Ошибка отправки данных';
			});
	}
</script>

<div class="container">
	<h3 id="form-feedback">Форма обратной связи / Заявка на проведение испытаний</h3>

	<fieldset class="form-feedback">
		<form method="POST" {onsubmit}>
			<label class="form-feedback__input"
				>Ваше имя

				<input name="name" placeholder="Введите ваше имя" required />
				<span class="d-none d-md-block">Обязательное поле</span>
				<span class="d-md-none">*</span>
			</label>

			<label class="form-feedback__input"
				>Ваш E-Mail

				<input name="email" type="email" placeholder="Введите ваше имя" required />
				<span class="d-none d-md-block">Обязательное поле</span>
				<span class="d-md-none">*</span>
			</label>

			<label class="form-feedback__input"
				>Ваш Телефон

				<input name="phone" type="tel" placeholder="Введите ваше имя" required />
				<span class="d-none d-md-block">Обязательное поле</span>
				<span class="d-md-none">*</span>
			</label>

			<div class="form-feedback__file">
				<span class="d-none d-md-inline">Прикрепите карточку с реквизитами компании</span>
				<label class="btn btn-yellow"
					>Загрузить
					<span class="d-md-none">карточку с реквизитами компании</span>

					<input
						type="file"
						name="card_file"
						accept="image/*, application/pdf, application/msword, application/odt"
					/>
				</label>

				<span>Допустимы файлы DOC, ODT, PDF, JPG</span>
			</div>

			<div class="form-feedback__textarea">
				<span>Дополнительная информация</span>
				<textarea name="description" required></textarea>
				<span class="d-none d-md-block">Обязательное поле</span>
				<span class="d-md-none">*</span>
			</div>

			<div class="form-feedback__checkbox">
				<label
					><input type="checkbox" required />
					<b
						>Отправляя заявку я соглашаюсь обработку моих персональных данных в соответствии с
						Ф3-152 от 27.07.2006 г. для целей проведения сделки и/или получения информации о
						продукции.
					</b></label
				>

				<div>
					<a
						href={'/images/files/poljzovateljskoe-soglashenie-mettatron.pdf'}
						target="_blank"
						onclick={(e) => {
							// e.preventDefault();
						}}>Пользовательское соглашение</a
					>
				</div>
				<div>
					<a
						href={'/images/files/obrabotka-personaljnyh-dannyh-mettatron.pdf'}
						target="_blank"
						onclick={(e) => {
							// e.preventDefault();
						}}>Обработка персональных данных</a
					>
				</div>
				<div>
					<a
						href={'/images/files/soglasie-na-obrabotku-personaljnyh-dannyh-mettatron.pdf'}
						target="_blank"
						onclick={(e) => {
							// e.preventDefault();
						}}>Согласие на обработку персональных данных</a
					>
				</div>
			</div>

			<div
				id="captcha-container"
				class="smart-captcha"
				data-sitekey="ysc1_IqbAVngS1LI9yoh7fucifCyh6yNcKQbMxEJzLy3v6602f861"
			></div>

			<div class="form-feedback__error">
				{errorMessage}
			</div>

			<div class="d-flex justify-content-center">
				<div class="d-flex justify-content-center">
					<button class="btn btn-yellow" type="submit">Отправить заявку / Запрос</button>
				</div>
			</div>
		</form>

		{#if isSended}
			<div class="form-feedback__success">Данные отправлены</div>
		{/if}
	</fieldset>
</div>

<style lang="sass">
=visually-hidden ()
	position: absolute
	display: block
	width: 1px
	height: 1px
	margin: -1px
	padding: 0
	overflow: hidden
	border: 0
	clip: rect(0 0 0 0)


:global
	#form-feedback
		font-weight: bold
		margin-bottom: 1rem

	.form-feedback
		border: 1px solid black
		padding: 2rem
		position: relative

		& form > * + *
			margin-top: 1rem

	.form-feedback__input
		position: relative
		width: 100%


		input
			width: 100%
			background-color: #F5F9FB
			border: 1px solid #999
			&:invalid
				border-color: red

		span
			display: block
			position: absolute
			color: red
			bottom: 0.1rem
			right: 1rem
			font-weight: normal

	.form-feedback__file
		display: flex
		gap: 1rem
		align-items: center

		input[type="file"]
			@include visually-hidden()

	.form-feedback__textarea
		position: relative

		textarea
			width: 100%
			border: 1px solid #999
			// background-color: #F5F9FB
			padding: 2rem 0.5rem 0.5rem
			min-height: 5rem
			&:invalid
				border-color: red

		span
			display: block
			position: absolute
			top: 0.25rem


			&:first-child
				left: 1rem
				color: #777
			&:not(:first-child)
				right: 1rem
				color: red

	.form-feedback__checkbox
		padding: 1rem
		border: 1px solid #999
		&:has(:invalid)
			border-color: red

	.form-feedback__error
		padding: 1rem
		color: red
		display: flex
		justify-content: center
		align-items: center

	.form-feedback__success
		display: flex
		justify-content: center
		align-items: center
		position: absolute
		top: 0
		bottom: 0
		left: 0
		right: 0
		font-weight: bold
		font-size: 2.5em
		color: #43b15e
		background-color: rgba(255,255,255,0.5)
		backdrop-filter: blur(5px)

</style>
